import { useMutation, useQueryClient } from "react-query";
import { addEmployeeBilingual } from "../../../../../actions/Utilities/EmployeeBilingual";
import { toast } from "../../../../../components/toastNotification";

const useAddEmployeeBilingual = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((data) => addEmployeeBilingual(data), {
    onSuccess: (res) => {
      queryClient.invalidateQueries();
      toast.fire("Success", "Added Employee Bilingual Successfully", "success");
    },
    onError: (error) => {
      toast.fire("Failed", "Failed to Add Employee Bilingual", "error");
    },
  });

  return mutate;
};
export default useAddEmployeeBilingual;
